<script lang="ts">
    import emailTemplateHandler from "$lib/utils/templating/emailTemplateHandler";
    import parseHandlebars, {findUnmatchedVariables} from "$lib/utils/templating/parseHandlebars";
    import {Editor, mergeAttributes, Node} from "@tiptap/core";
    import {LetterBoldOutline, LetterItalicOutline, ListOutline} from "flowbite-svelte-icons";
    import {Dropdown, DropdownItem, Toggle} from "flowbite-svelte";
    import type {EmailTemplate} from "$lib/types/EmailTemplate";
    import type {Employee} from "$lib/types/employee";
    import {createEventDispatcher, onDestroy, onMount} from "svelte";
    import Sleep from "$lib/utils/sleep";
    import Link from "@tiptap/extension-link";
    import TipTapEditor from "$lib/utils/TipTapEditor";

    export let template: EmailTemplate;

    export let fillData: {Employee: Employee, Input?:any, Unit?:any, Contract?:any};

    export let preview = false;

    let editor:Editor;
    let contentParts: {content: string, type: string}[] = [];

    let externalTemplate = {...template}

    const dispatch = createEventDispatcher()


    const initialiseTemplate = async (skipParsing = false) => {

        contentParts = emailTemplateHandler(externalTemplate)
        externalTemplate.content = contentParts.map(part => {
            let string = '';
            if(part.type === 'render' || preview){
                string = editor && part.type === 'edit' ? editor.getHTML() : parseHandlebars({...externalTemplate,content: part.content}, fillData)
            } else {
                string = '<div class="py-1 " id="editor"></div>'
            }
            return string
        }).join('')
        if(preview){
            dispatch('update', {
                ...externalTemplate,
            })
        }
        if(editor){
            editor.destroy()
            await Sleep(200);
        }
       /* email.variables = findUnmatchedVariables(email.template.content)
        email.subject = template.name*/

        setTimeout(() =>{
            if(!preview){
                initializeEditor()
            }
        },300)

    }
    const initializeEditor = () => {
        const editorContent = parseHandlebars({...externalTemplate, content: contentParts[1].content}, fillData)
        editor = TipTapEditor(document.querySelector('#editor') || undefined,
            (newContent: string) => {
                const content = contentParts.map(part => {
                    let string = '';
                    if(part.type === 'render'){
                        string = parseHandlebars({...externalTemplate,content: part.content}, fillData)
                    } else {
                        string = newContent
                    }
                    return string
                }).join('')
                dispatch('update', {
                    ...externalTemplate,
                    content: content
                })}, editorContent)

    }

    onMount(() => {
        initialiseTemplate()
    })
    onDestroy(() => {
        if(editor){

            editor.destroy()
        }
    })
</script>
<div class="flex mb-2">
    <Toggle bind:checked={preview} on:change={() => initialiseTemplate(true)}>Vorschau</Toggle>
</div>
{#if !preview}
<div class="bubble-menu flex gap-2">
    <button class="bg-background-500 p-1 rounded-lg" type="button" on:click={() => editor.commands.toggleBulletList()}>
        <ListOutline class="w-4"/>
    </button>
    <button class="bg-background-500 p-1 rounded-lg" type="button" on:click={() => editor.commands.toggleBold()}>
        <LetterBoldOutline class="w-4"/>
    </button>
    <button class="bg-background-500 p-1 rounded-lg" type="button" on:click={() => editor.commands.toggleItalic()}>
        <LetterItalicOutline class="w-4"/>
    </button>
    <button class="bg-background-500 p-1 rounded-lg" type="button" >
        <div class="w-4 h-4 bg-gradient-to-bl from-[#5e6977] to-[#a3c7ea]"></div>
        <Dropdown>
            <DropdownItem on:click={() => editor.chain().focus().setColor('#ffffff').run()}><div class="w-4 h-4 bg-white"></div></DropdownItem>
            <DropdownItem on:click={() => editor.chain().focus().setColor('#000000').run()}><div class="w-4 h-4 bg-[#000000]"></div></DropdownItem>
            <DropdownItem on:click={() => editor.chain().focus().setColor('#5e6977').run()}><div class="w-4 h-4 bg-[#5e6977]"></div></DropdownItem>
            <DropdownItem on:click={() => editor.chain().focus().setColor('#839ebf').run()}><div class="w-4 h-4 bg-[#839ebf]"></div></DropdownItem>
            <DropdownItem on:click={() => editor.chain().focus().setColor('#a3c7ea').run()}><div class="w-4 h-4 bg-[#a3c7ea]"></div></DropdownItem>
            <DropdownItem on:click={() => editor.chain().focus().setColor('#DE170D').run()}><div class="w-4 h-4 bg-[#DE170D]"></div></DropdownItem>
        </Dropdown>
    </button>
</div>
{/if}
<div>
    {@html externalTemplate.content}
</div>
